export const uiTranslations = {
  // Hero 组件
  "exploreBeautifulPenang": {
    en: "Explore Beautiful Penang",
    zh: "探索美丽的槟城"
  },
  "discoverMalaysia": {
    en: "Discover Malaysia's cultural paradise and find everything you need as a visitor, student, or new resident.",
    zh: "发现马来西亚的文化天堂，获取作为游客、学生或新居民所需的一切信息。"
  },
  "getStarted": {
    en: "Get Started",
    zh: "开始探索"
  },
  "searchPlaceholder": {
    en: "Search for services, guides, or information...",
    zh: "搜索服务、指南或信息..."
  },
  "searchButton": {
    en: "Search",
    zh: "搜索"
  },
  
  // FeaturedDestinations 组件
  "discoverPenangTreasures": {
    en: "Discover Penang's Treasures",
    zh: "发现槟城的瑰宝"
  },
  "exploreCulturalDestinations": {
    en: "Explore the island's most beautiful and culturally significant destinations",
    zh: "探索这座岛屿最美丽和最具文化意义的目的地"
  },
  "viewAllDestinations": {
    en: "View All Destinations",
    zh: "查看所有目的地"
  },
  "discoverMore": {
    en: "Discover more →",
    zh: "了解更多 →"
  },
  
  // 目的地名称和描述
  "georgetownHeritage": {
    en: "Georgetown Heritage",
    zh: "乔治城文化遗产"
  },
  "georgetownDescription": {
    en: "Explore the UNESCO World Heritage Site with its unique cultural blend and historic architecture.",
    zh: "探索这座联合国教科文组织世界遗产地，体验其独特的文化融合和历史建筑。"
  },
  "penangHill": {
    en: "Penang Hill",
    zh: "升旗山"
  },
  "penangHillDescription": {
    en: "Take a scenic funicular railway ride to enjoy panoramic views of the island from 833m above sea level.",
    zh: "乘坐风景如画的缆车，在海拔833米的高度欣赏岛屿的全景。"
  },
  "kekLokSiTemple": {
    en: "Kek Lok Si Temple",
    zh: "极乐寺"
  },
  "kekLokSiDescription": {
    en: "Visit Malaysia's largest Buddhist temple complex with its impressive architecture and gardens.",
    zh: "参观马来西亚最大的佛教寺庙建筑群，欣赏其令人印象深刻的建筑和花园。"
  },
  "batuFerringhiBeach": {
    en: "Batu Ferringhi Beach",
    zh: "峇都丁宜海滩"
  },
  "batuFerringhiDescription": {
    en: "Relax at this popular beach destination known for its soft white sand and water sports activities.",
    zh: "在这个以柔软的白沙和水上运动活动而闻名的热门海滩目的地放松身心。"
  },
  
  // Testimonials 组件
  "whatPeopleSay": {
    en: "What People Say About Us",
    zh: "大家对我们的评价"
  },
  "hearFromUsers": {
    en: "Hear from users who have experienced our services",
    zh: "听听体验过我们服务的用户的评价"
  },
  
  // 通用页面元素
  "helpYouMakeTheMost": {
    en: "Let us help you make the most of your time in Penang. Whether you're studying, visiting, or relocating, we've got you covered.",
    zh: "让我们帮助您充分利用在槟城的时间。无论您是学习、参观还是搬迁，我们都能满足您的需求。"
  },
  "contactUs": {
    en: "Contact Us",
    zh: "联系我们"
  },
  "copyright": {
    en: "Copyright 2024 Penang Gateway. All rights reserved.",
    zh: "版权所有 2024 槟城门户。保留所有权利。"
  },
  "discoverTopAttractions": {
    en: "Discover the top attractions, experiences, and hidden gems of Malaysia's island paradise",
    zh: "探索马来西亚岛屿天堂的顶级景点、体验和隐藏的宝藏"
  },
  "customTourPackages": {
    en: "Custom Tour Packages",
    zh: "定制旅游套餐"
  },
  "topAttractionsDescription": {
    en: "From UNESCO heritage sites to pristine beaches and culinary adventures, Penang offers unforgettable experiences for every traveler.",
    zh: "从联合国教科文组织遗产地到原始海滩和美食冒险，槟城为每位旅行者提供难忘的体验。"
  },
};
